/**
 * Die Aufteilung der Antwortkacheln.
 *
 * Steht getrennt von der Komponente, weil es reine Rechnerei ist und auch so
 * geprüft werden soll - dasselbe Muster wie bei adresse.ts.
 */

/**
 * Wie viele Kacheln in eine Reihe gehören.
 *
 * Feste vier Spalten ließen bei fünf Antworten die letzte allein in der
 * zweiten Reihe stehen - das sieht nach einem Fehler aus und lenkt genau auf
 * die Antwort, die zufällig übrig blieb.
 *
 * Deshalb richtet sich die Spaltenzahl nach der Anzahl:
 *
 *   bis fünf   alle in eine Reihe
 *   darüber    die Teilung, die keinen Einzelgänger übrig lässt
 *
 * Sechs werden also 3 und 3, sieben werden 4 und 3, zehn werden 5 und 5.
 * Bevorzugt wird vier: Breiter als fünf, ruhiger als drei.
 */
export function spaltenFuer(anzahl: number): number {
  if (anzahl <= 5) return Math.max(anzahl, 1);

  // Erst eine Teilung ohne Rest.
  for (const spalten of [4, 5, 3]) {
    if (anzahl % spalten === 0) return spalten;
  }
  // Sonst eine, bei der die letzte Reihe mindestens zwei trägt.
  for (const spalten of [4, 5, 3]) {
    if (anzahl % spalten >= 2) return spalten;
  }
  return 4;
}
